import React , { useContext } from 'react';
import MealItemStyle from './MealItem.module.css' ;

import MealItemForm from './MealItemForm';
import CartContext from '../../../store/cart-contex';

function MealItem(props) {
    const cartCtx = useContext(CartContext) ;
    const price = `$${props.price.toFixed(2)}` ;

    function addToCartHandler(amount) {
      cartCtx.addItem({
        id: props.id ,
        name: props.name ,
        amount: amount ,
        price: props.price
      })
    }

  return (
    <li className={MealItemStyle.meal}>

        <div>
            <h3>{props.name}</h3>
            <div className={MealItemStyle.description}>{props.description}</div>
            <div className={MealItemStyle.price}>{price}</div>
        </div>

        <div>
            <MealItemForm id={props.id} onAddToCart={addToCartHandler} />
        </div>
        
    </li>
  )
}

export default MealItem;